(ns app.endpoints)

(def strive-react-endpoint "https://live.ninja.usestrive.com")
(def strive-live-react-endpoint "https://live.ninja.usestrive.com")

(def backend-endpoint "https://strive-clojure-twsbos4a7q-ew.a.run.app")
;;  (def backend-endpoint "http://localhost:8080")

(def firebase-token-login (str backend-endpoint "/api/v1/firebase-token-login"))
(def reset-password-endpoint "https://strive-clojure-twsbos4a7q-ew.a.run.app/api/v1/reset-password?access_token=9a349e22-d20d-11e9-bb65-2a2ae2dbcce4")
(def verify-email-endpoint "https://clojure-authentication-twsbos4a7q-ew.a.run.app/api/v1/verify-email?access_token=9a349e22-d20d-11e9-bb65-2a2ae2dbcce4")
(def workspaces-endpoint (str backend-endpoint "/api/v1/secured/workspace/"))
(def resend-verification-code "https://strive-clojure-twsbos4a7q-ew.a.run.app/api/v1/resend-verification-code")

(defn reauthenticate [workspace-id]
  (str "https://clojure-authentication-twsbos4a7q-ew.a.run.app/api/v1/secured/reauthenticate?skipNull=true&skipEmptyString=true&is_app=false&tenant_id=" workspace-id))
(defn update-workspace-name-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/update-name"))
(defn update-account-display-name-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/update-display-name"))

(defn update-workspace-icon-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/update-icon"))
(defn update-user-icon-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/update-user-icon"))

(defn delete-workspace-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/"))
(defn folders-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/"))
(defn add-folder-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/"))
(defn get-statistics-folder-data-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/get-statistics-folder-data"))
(defn get-products-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/products"))
(defn get-workspace-products-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/products"))
(defn get-workspace-forms-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/forms"))
(defn get-forms-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/forms"))
(defn update-folder-name-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/update-name"))
(defn delete-folder-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/delete-to-trash"))
(defn empty-trash-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/empty-trash-of-folders"))

(defn restore-folder-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/restore-folder"))

(defn update-form-name [folder-id form-id]
  (str backend-endpoint "/api/v1/secured/folder/" folder-id "/form/" form-id "/update-name"))
(defn update-product-name [folder-id product-id]
  (str backend-endpoint "/api/v1/secured/folder/" folder-id "/product/" product-id "/update-name"))

(defn move-product-endpoint [folder-id product-id]
  (str backend-endpoint "/api/v1/secured/folder/" folder-id "/product/" product-id "/move"))
(defn move-form-endpoint [folder-id form-id]
  (str backend-endpoint "/api/v1/secured/folder/" folder-id "/form/" form-id "/move"))
(defn delete-form-endpoint [workspace-id folder-id form-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/form/" form-id "/delete-to-trash"))
(defn duplicate-form-endpoint [workspace-id folder-id form-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/form/" form-id "/duplicate"))
(defn delete-product-endpoint [workspace-id folder-id product-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/product/" product-id "/delete-to-trash"))

(defn duplicate-product-endpoint [workspace-id folder-id product-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/product/" product-id "/duplicate"))

(defn upload-image-endpoint []
  (str "https://strive-api.usestrive.com/api/v1/image-upload?&&&file_name=true&compress=uploads"))

(defn folder-link [workspace-id folder-id]
  (str strive-react-endpoint "/dashboard/" workspace-id "/folder/" folder-id))
(defn copy-form-endpoint [workspace-id folder-id form-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/form/" form-id "/copy"))
(defn copy-product-endpoint [workspace-id folder-id product-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/product/" product-id "/copy"))

(defn reorder-workspaces-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/reorder"))

(defn restore-assets-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/restore"))
(defn delete-assets-permanently-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/delete-permanent"))

(defn delete-assets-to-trash-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/delete-multiple-to-trash"))
(defn move-multiple-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/move-multiple"))
(defn copy-multiple-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/copy-multiple"))

(defn deleted-assets-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/deleted-assets"))

(defn get-recent-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/get-recent-products"))

(defn get-statistics-data-endpoint [workspace-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/get-statistics-data"))

(defn check-folder-status-endpoint [workspace-id folder-id]
  (str backend-endpoint "/api/v1/secured/workspace/" workspace-id "/folder/" folder-id "/check-status"))

(def strive-backend-endpoint "https://strive-api.usestrive.com")
;; (def strive-backend-endpoint "http://localhost:8020")

(defn fetch-secured-hidden-fields [secured-key]
  (str strive-backend-endpoint "/api/v1/strive-forms/secured-hidden-fields?secured_fields_key=" secured-key))

(defn get-strive-forms-fields [form-id query-params]
  (str strive-backend-endpoint "/api/v1/strive-forms/" form-id "/published" query-params))

(defn fetch-form-messages-endpoint [form-id selected-language]
  (str strive-backend-endpoint "/api/v1/strive-forms-messages/" form-id "?language=" selected-language))

(defn submit-form [form-id]
  (str strive-backend-endpoint "/api/v1/strive-forms/" form-id "/submit"))

(defn cache-form [form-id]
  (str strive-backend-endpoint "/api/v1/strive-forms/" form-id "/cache"))

(defn get-form-icon [form-id]
  (str backend-endpoint "/api/v1/secured/strive-forms/" form-id "/icon"))

(def get-ip-address 
  "https://ipapi.co/json/")

(def send-grid-api
  "https://api.sendgrid.com/v3/validations/email")

(def send-grid-token-api 
  "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")

(def json-body 
  "{ \"email\": \"harel.n.y@gmail.com\" , \"source\" : \"signup\" }")
